var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionSmallFilterDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6)",
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 13,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 1,
    width: 8,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 25 0)",
    x: 10,
    width: 5,
    height: 5,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 13)",
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 9,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 1,
    width: 12,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 17 0)",
    x: 6,
    width: 5,
    height: 5,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 20)",
    fill: "#1B7690"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 1,
    width: 6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 0 0 1 29 0)",
    x: 12,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 16,
    height: 3,
    rx: 1.5
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionSmallFilterDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-small-filter-default.b188a83a5353ee5c068625297ca80d27.svg";